module.exports = __webpack_public_path__ + "static/img/Mobiya01_product-photo.5023c81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Mobiya01_product-photo.jpg
// module id = 8MWd
// module chunks = 0